<template>
  <div class="home">
    <TopHeader></TopHeader>
    <b-container fluid="xl">
      <b-row class="mt-4 d-md-flex">
        <ListLead></ListLead>
      </b-row>
      <b-row align-h="between" class="mt-3 mt-md-4">
        <b-col cols="12" class="px-3 mb-3">
          <b-row no-gutters align-v="center">
            <b-col>
              <FormCheckbox v-model="isFilterVisibilityOn" role="switch" name="open-filter">
                <template #label>
                  <p class="text-base text-blue-500 mb-0 mt-1">
                    {{ filtersText }}
                  </p>
                </template>
              </FormCheckbox>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="getFiltersVisibility"
          cols="12"
          class="border-bottom border-blue-50 border-2 px-0"
        >
        </b-col>
        <transition name="slide-fade" v-on:before-enter="beforeEnter" v-on:after-leave="afterLeave">
          <b-col v-show="isFilterVisibilityOn" cols="12" lg="4" class="px-0 pr-lg-3">
            <ChildrenFilter></ChildrenFilter>
          </b-col>
        </transition>
        <b-col cols="12" :lg="getFiltersVisibility ? '8' : '12'" class="mt-3">
          <div v-if="isOpenFundraising && getChildrenAmount > 0" class="mb-3">
            <p class="text-lg text-blue-500 font-weight-bold mb-0">
              {{ $t('childrenFilter.openFundraising') }}
            </p>
          </div>
          <p v-if="showChildrenAmount" class="text-base text-blue-500">
            {{ childrenAmountText }}
          </p>
          <SelectedFilters></SelectedFilters>
          <ChildrenList :initLoader="initLoader"></ChildrenList>
        </b-col>
      </b-row>
    </b-container>
    <BottomSection></BottomSection>
    <FaqSection :content="$tm('faq.childPageContent')"></FaqSection>
    <ScrollTopButton></ScrollTopButton>
    <AppFooter ovalBackground="bg-salmon-500"></AppFooter>
  </div>
</template>
<script>
import { createHelpers } from 'vuex-map-fields'

import ChildrenFilter from '@/components/childrenFilter/ChildrenFilter.vue'
import SelectedFilters from '@/components/childrenFilter/SelectedFilters.vue'
import ChildrenList from '@/components/childrenList/ChildrenList.vue'
import AppFooter from '@/components/global/AppFooter.vue'
import ListLead from '@/components/home/ListLead.vue'
import TopHeader from '@/components/home/TopHeader.vue'
import BottomSection from '@/components/home/bottomSection/BottomSection.vue'
import FaqSection from '@/components/widgets/FaqSection.vue'
import ScrollTopButton from '@/components/widgets/ScrollTopButton.vue'
import FormCheckbox from '@/components/widgets/forms/FormCheckbox.vue'

import appliedFilters from '@/mixins/appliedFilters'
import storage from '@/services/storage/sessionStorage'

const { mapFields } = createHelpers({
  getterType: 'filter/getFiltersVisibilityField',
  mutationType: 'filter/updateFiltersVisibilityField'
})

export default {
  name: 'HomePage',
  mixins: [appliedFilters],
  components: {
    TopHeader,
    ListLead,
    ChildrenFilter,
    ChildrenList,
    SelectedFilters,
    BottomSection,
    ScrollTopButton,
    AppFooter,
    FaqSection,
    FormCheckbox
  },
  data() {
    return {
      isFilterVisibilityOn: false,
      initLoader: false
    }
  },
  computed: {
    ...mapFields(['filtersVisibility']),
    getChildrenAmount() {
      return this.$store.getters['filter/getChildrenList'].number
    },
    currentOffset() {
      return this.$store.getters['filter/getPagination'].offset
    },
    getFiltersVisibility() {
      return this.$store.getters['filter/getFiltersVisibility']
    },
    showChildrenAmount() {
      return (this.hasAppliedFilters || this.isOpenFundraising) && this.getChildrenAmount > 0
    },
    childrenAmountText() {
      return this.$t(
        'childrenFilter.meetChildrenAmount',
        {
          amount: this.getChildrenAmount
        },
        this.getChildrenAmount
      )
    },
    filtersText() {
      return this.getFiltersVisibility
        ? this.$t('childrenFilter.label.hideFilters')
        : this.$t('childrenFilter.label.showFilters')
    }
  },
  watch: {
    getFiltersVisibility: {
      handler(filtersVisibility, oldFiltersVisibility) {
        if (filtersVisibility && oldFiltersVisibility == null) {
          this.isFilterVisibilityOn = true
        }
      },
      immediate: true
    }
  },
  methods: {
    beforeEnter() {
      this.filtersVisibility = this.isFilterVisibilityOn
    },
    afterLeave() {
      this.filtersVisibility = this.isFilterVisibilityOn
    },
    setIsFilterVisibilityOn(flag) {
      this.isFilterVisibilityOn = flag
    },
    setInitLoader(flag) {
      this.initLoader = flag
    }
  },
  beforeRouteEnter(to, from, next) {
    const pages = [null, 'ChildPage']
    const clearFilters = !pages.includes(from.name)
    const query = to.query || null
    const openFundraising = query && Object.hasOwn(query, 'zbiorki')
    const parameters = storage.get('params', true) || {}

    next((vm) => {
      vm.$store.commit('child/setPaidAmount', null)
      if (clearFilters) {
        vm.$store.commit('filter/clearParametersStorage')
        vm.$store.commit('filter/clearPagination')
        vm.$store.commit('filter/setParameters')
        vm.$store.commit('filter/clearChildrenList')
      }
      // if user comes from route with 'zbiorka' query param:
      // -update sessionStorage
      // -remove query params from url to avoid two sources of truth
      if (openFundraising) {
        parameters.openFundraising = openFundraising
        storage.set('params', { ...parameters }, true)
        vm.$router.replace({
          ...to,
          query: null
        })
      }
      vm.$store.commit('filter/setParameters', parameters)

      if (vm.currentOffset === 0) {
        vm.setInitLoader(true)
        vm.$store.dispatch('filter/getFilter').finally(() => {
          if (vm.hasAppliedFilters) {
            vm.setIsFilterVisibilityOn(true)
          }
          vm.setInitLoader(false)
        })
      }
      vm.$store.dispatch('filter/getResourceFilter')
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('filter/setParameters')
    next()
  },
  created() {
    FormCheckbox.compatConfig = { MODE: 3 }
  }
}
</script>
<style lang="scss">
.home {
  overflow-x: hidden;
}
</style>
